export * from './h2-icon';
